import { ITextInputProps, TextInput } from 'components/ui/Input/TextInput'
import { useInlineSettings } from '../TaskCreation/contexts/InlineSettingsContext'
import React, { forwardRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { isRtlSelector } from 'redux/selectors/general'

interface TaskInputProps extends ITextInputProps {
  isError?: boolean
  inputElement?: React.ReactNode
}

export const TaskInput = forwardRef<HTMLInputElement, TaskInputProps>(
  ({ isError, inputElement, onFocus, onBlur, borderRadius, boxShadow, ...props }, ref) => {
    const inlineSettings = useInlineSettings()
    const isRTL = useSelector(isRtlSelector)
    const [isFocused, setIsFocused] = useState(false)

    const wrappedElement = inputElement ? (
      <span
        style={{ opacity: isFocused ? 0 : 1, transition: 'opacity 0.15s', pointerEvents: isFocused ? 'none' : 'auto' }}
      >
        {inputElement}
      </span>
    ) : null

    return (
      <TextInput
        ref={ref}
        elementHeight="40px"
        borderRadius={inlineSettings ? '8px' : borderRadius || '12px'}
        boxShadow={inlineSettings ? 'none' : boxShadow || (isError ? '0px 0px 0px 3px #EA9999' : 'md')}
        maxLength={100}
        borderWidth="1px"
        fontSize="16px"
        color="inherit"
        _active={{ borderColor: 'transparent' }}
        _focus={{ borderColor: 'transparent' }}
        onFocus={(event) => {
          setIsFocused(true)
          onFocus?.(event)
        }}
        onBlur={(event) => {
          setIsFocused(false)
          onBlur?.(event)
        }}
        {...(isRTL
          ? { leftIcon: wrappedElement, leftIconClickable: true }
          : { rightIcon: wrappedElement, rightIconClickable: true })}
        {...props}
        {...(inlineSettings
          ? {
              border: '1px solid',
              borderColor: isError ? '#EA9999' : '#E2E8F0',
              isInvalid: isError,
            }
          : {})}
      />
    )
  }
)
